import { useMemo } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { calculateWeeklyDigest } from '@/lib/weekly-digest';
import { formatAUD } from '@/lib/format';
import { TrendingDown, TrendingUp, Minus, Flame, Newspaper } from 'lucide-react';

export function WeeklyDigest() {
  const { data } = useAuth();
  const digest = useMemo(() => calculateWeeklyDigest(data), [data]);

  const TrendIcon = digest.changeDirection === 'down' ? TrendingDown
    : digest.changeDirection === 'up' ? TrendingUp
    : Minus;

  const trendColor = digest.changeDirection === 'down' ? 'text-success'
    : digest.changeDirection === 'up' ? 'text-destructive'
    : 'text-muted-foreground';

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
            <Newspaper className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">This Week</p>
            <p className="font-display text-xl font-bold">{formatAUD(digest.thisWeekSpending)}</p>
          </div>
          {digest.lastWeekSpending > 0 && (
            <div className={`ml-auto flex items-center gap-1 ${trendColor}`}>
              <TrendIcon className="h-4 w-4" />
              <span className="text-sm font-medium">{digest.changePercent}%</span>
            </div>
          )}
        </div>

        <p className="text-sm mb-2">{digest.encouragement}</p>

        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          {digest.topCategory && (
            <span>Top: <strong className="text-foreground">{digest.topCategory}</strong> ({formatAUD(digest.topCategoryAmount)})</span>
          )}
          {digest.streakDays > 0 && (
            <span className="flex items-center gap-1">
              <Flame className="h-3 w-3 text-destructive" />
              {digest.streakDays}d tracking streak
            </span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
